import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { JustificateTransportActions } from "store/ducks/transports";

export function* justificateTransportsRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/transports/justificate/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(JustificateTransportActions.success(data));
    notify("success", "Atraso justificado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(JustificateTransportActions.failure(errorMessage));
  }
}
